(function($) {
  $(document).ready(function() {
    /* ==== PASSWORD ==== */

    /**
     * Form Submit Handler
     */
    $('.form-password-submit').click(function(event) {
      event.preventDefault();

      $('.waiting').addClass('show');
      var actualPassword = $('#actual-password').val();
      var newPassword = $('#new-password').val();
      var confimPassword = $('#confirm-password').val();
      var valid = false;

      $('#password-form .response').empty();

      // Validation
      if (
        actualPassword !== '' && 
        newPassword !== '' && 
        confimPassword !== ''
      ) {
        valid = true;
      } else {
        // TODO: Update language handling (use variable from functions.php)
        if ($('html').attr('lang') === 'fr-FR') {
          $('#password-form .response').html('Veuillez remplir tous les champs.');
        } else {
          $('#password-form .response').html('Please fill in all fields.');
        }
      }

      if (valid) {
        var formData = $('#password-form').serialize();

        $.ajax({
          url: ajax_object.ajaxurl,
          type: 'POST',
          data: {
            action: 'ajax_action_password_validation',
            form: formData,
          },
          success: function(response) {
            response = $.parseJSON(response);
            $('#password-form .response').html(response.message);
            $('#actual-password').val('');
            $('#new-password').val('');
            $('#confirm-password').val('');
            $('.waiting').removeClass('show');
          },
          error: function(response) {
            response = $.parseJSON(response);
            $('#password-form .response').html(response.message);
            $('.waiting').removeClass('show');
          },
        });
      }
    });
  });
})(jQuery);
